import React, { MouseEventHandler } from 'react';
import styled from 'styled-components';
import SectionWrapper from 'components/SubLandingPage/Duo/SectionWrapper';
import Type from 'components/Type';
import UnderlinedLink from 'components/Link/UnderlinedLink';
import * as tokens from 'styles';
import { PrimaryButton } from 'components/Button/PrimaryButton';
import SectionHeadline from 'components/SubLandingPage/SectionHeadline';
import LeadParagraph from 'components/SubLandingPage/LeadParagraph';
import { useTranslation } from 'data/translation/useTranslation';

const TermsConditions = styled(Type.P)`
  margin-top: ${tokens.spacer16};
`;

const ContentWrapper = styled.div`
  max-width: 390px;
  margin: 0 auto;
`;

type AcceptDisplayProps = {
  joinUrl: string;
  termsUrl: string;
  onJoinClick: MouseEventHandler;
  onTermsClick: MouseEventHandler;
};

const AcceptDisplay = ({
  joinUrl,
  termsUrl,
  onJoinClick,
  onTermsClick,
}: AcceptDisplayProps) => {
  const { t } = useTranslation();

  return (
    <SectionWrapper>
      <ContentWrapper>
        {/* eslint-disable @spotify-internal/wtb-rules/no-danger-styled */}
        <SectionHeadline
          dangerouslySetInnerHTML={{
            __html: t('sub_landing_page.duo_music_for_two'),
          }}
          paddingBottom={tokens.spacer32}
        />
        <LeadParagraph
          dangerouslySetInnerHTML={{
            __html: t('sub_landing_page.two_accounts_living_together'),
          }}
        />
        {/* eslint-enable @spotify-internal/wtb-rules/no-danger-styled */}

        <PrimaryButton href={joinUrl} onClick={onJoinClick} $alternateDuo>
          {t('sub_landing_page.accept_invite')}
        </PrimaryButton>
        <TermsConditions>
          <UnderlinedLink href={termsUrl} onClick={onTermsClick}>
            {t('sub_landing_page.terms.link')}
          </UnderlinedLink>
        </TermsConditions>
      </ContentWrapper>
    </SectionWrapper>
  );
};

export default AcceptDisplay;
